import axios from 'axios';
import { mutate } from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { IStateProductRestrictionPayload } from '../interfaces';

const BASE_URL = `/${SERVICES.PRODUCT}/producttypes`;
const CREATE_URL = 'create-producttype-staterule';
const UPDATE_URL = 'update-producttype-staterule';
const DELETE_URL = 'delete-producttype-staterule';

export const requestCreateStateProductRestriction = (data: IStateProductRestrictionPayload) => {
  return mutate(BASE_URL, async () => {
    try {
      await axios.post(`${BASE_URL}/${CREATE_URL}`, data);

      Notistack.successMessage('Product Restriction - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateStateProductRestriction = (data: IStateProductRestrictionPayload) => {
  return mutate(BASE_URL, async () => {
    try {
      await axios.put(`${BASE_URL}/${UPDATE_URL}`, data);

      Notistack.successMessage('Product Restriction - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteStateProductRestriction = (id: string) => {
  return mutate(BASE_URL, async () => {
    try {
      await axios.delete(`${BASE_URL}/${DELETE_URL}/${id}`);

      Notistack.successMessage('Product Restriction - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
